module.exports = "https://coursera_assets.s3.amazonaws.com/images/d324d318c79ee0de97fc11c7c70e1972.svg";